<template>
  <div class="p-0">
    <p class="label__form-name-header">
      Check your name that will be generated to your certificate
    </p>
    <b-form ref="form__name-on-boarding">
      <b-row class="row__form-input">
        <!-- firstname -->
        <b-col class="pr-sm-2">
          <label for="firstname" class="label__input-name">Name and middle name</label>
          <b-form-input
            id="firstname"
            ref="form__on-boarding-firstname"
            v-model="form.firstname"
            type="text"
            placeholder="Name and middle name"
            class="input__name"
            :state="errorState('firstname')"
            :disabled="!isEligibleName.isEligible"
          >
          </b-form-input>
          <b-form-invalid-feedback
            v-if="isShowRequiedFeedbackText('firstname')"
            ref="input__error-required"
            class="text_feedback"
          >
            Name and middle name is required
          </b-form-invalid-feedback>
        </b-col>

        <!-- lastname -->
        <b-col class="pl-sm-2">
          <label for="surname" class="label__input-lastname">Surname</label>
          <b-form-input
            id="lastname"
            ref="form__on-boarding-lastname"
            v-model="form.lastname"
            type="text"
            placeholder="Surname"
            class="input__lastname"
            :state="errorState('lastname')"
            :disabled="!isEligibleName.isEligible"
          >
          </b-form-input>
          <b-form-invalid-feedback
            v-if="isShowRequiedFeedbackText('lastname')"
            ref="input__error-required"
          >
            Surname is required
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </b-form>

    <p v-if="!isEligibleName.isEligible" class="text-form_feedback mt-2 mb-0">
      Your name can be changed again on {{ isEligibleName.canChangeDate }}
    </p>
    <b-button
      variant="outline-primary"
      class="mt-3 button__modal-certificate-example"
      @click="isShowPreview = true"
    >
      Preview Certificate Sample
    </b-button>
    <modal-certificate-example
      ref="preview-certificate-modal"
      v-model="isShowPreview"
      :firstname="form.firstname"
      :lastname="form.lastname"
    />
  </div>
</template>

<script>
import ModalCertificateExample from '../../Profile/components/ModalCertificateExample.vue';
import { required } from 'vuelidate/lib/validators';
export default {
  components: {
    ModalCertificateExample
  },
  props: {
    firstname: {
      type: String,
      required: true
    },
    lastname: {
      type: String,
      required: true
    },
    isEligibleName: {
      type: Object,
      default: () => {
        return {
          isEligible: false,
          canChangeDate: ''
        };
      }
    }
  },
  data() {
    return {
      isShowPreview: false,
      form: {
        firstname: '',
        lastname: ''
      }
    };
  },
  validations() {
    return {
      form: {
        firstname: {
          required
        },
        lastname: {
          required
        }
      }
    };
  },
  created() {
    this.updateUserData();
  },
  methods: {
    updateUserData() {
      this.$set(this.form, 'firstname', this.firstname);
      this.$set(this.form, 'lastname', this.lastname);
    },

    onSubmitName() {
      this.$v.$touch();

      this.$emit('submit:name-on-borading', this.form);
    },

    errorState(key) {
      return this.$v.form[key].$dirty
        ? this.$v.form[key].$anyError
          ? !this.$v.form[key].$anyError
          : null
        : null;
    },

    isShowRequiedFeedbackText(dataKey) {
      return this.isErrorFeedbackText(dataKey, 'required');
    },

    //return true if NOT meet requirment
    isErrorFeedbackText(dataKey, errorKey) {
      return this.$v.form[dataKey].$dirty ? !this.$v.form[dataKey][`${errorKey}`] : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.label__form-name-header {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 1.5rem;
}

@media screen and (max-width: 575px) {
  .row__form-input {
    flex-direction: column;
    gap: 1rem;
  }
}
.text-form_feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 14px;
  color: #f83245;
}
</style>
